export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-path/index.js
// module id = 15
// module chunks = 0 1 2 3 4